export const QuestionType = {
  CHECKBOX: "CHECKBOX",
  MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
};
